export const SESSION_STORAGE = {
    DELETED_ACCOUNT_TOKEN: 'jdy.deleted_account_token' // 已注销企业零时登录凭证
};
